import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";
import MedicinesListBody from "components/ClinicalManagement/Medicines/MedicinesListBody";

const Medicines = () => {
  useEffect(() => {
    document.title = "Medicines";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <MedicinesListBody />
    </main>
  );
};

export default Medicines;
